export const GET_LOGS = 'GET_LOGS';
export const SET_LOGS = 'SET_LOGS';
export const RESET_LOGS = 'RESET_LOGS';
export const GET_LOG_REPORT_AS_PDF = 'GET_LOG_REPORT_AS_PDF';
export const GET_LOG_REPORT_AS_XML = 'GET_LOG_REPORT_AS_XML';
export const SET_LOG = 'SET_LOG';

export const getLogReportAsPdf = () => ({
    type: GET_LOG_REPORT_AS_PDF
})
export const getLogReportAsXml = () => ({
    type: GET_LOG_REPORT_AS_XML
})

export const getLogs = () => ({
    type: GET_LOGS
})

export const setLogs = (logs: any) => ({
    type: SET_LOGS,
    logs
})
export const setLog = (log: any) => ({
    type: SET_LOG,
    log
})

const initialState = {
    logs: null
}

export const logReducer = (state = initialState, action: any) => {

    const { logs } = action;
    const { log } = action;

    switch (action.type) {
        case SET_LOGS:
            return { ...state, logs };
        case SET_LOG:
            return { ...state, log };
        case RESET_LOGS:
            return initialState;
        default:
            return state
    }
}